<template>
  <div id="myAdvisory">
    <Breadcrumb></Breadcrumb>
    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form
          ref="form"
          :model="queryParams"
          label-width="80px"
          size="small"
        >
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="词：" prop="term">
                <el-input
                  size="small"
                  v-model="queryParams.term"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="中文词：" prop="termCn">
                <el-input
                  size="small"
                  v-model="queryParams.termCn"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="添加时间：" prop="time">
                <el-date-picker
                  v-model="queryParams.time"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col style="margin-top: 8px" :span="8" class="btn-bar-right">
              <el-button type="primary" size="small" @click="loadData"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="form-body">
      <div style="overflow:hidden;">
        <span style="float:left;">
          <el-button type="primary" size="small" @click="handleShowEdit({})"
            >新增</el-button
          >
          <el-button size="small" type="primary" @click="showClassification"
            >分类管理</el-button
          >
        </span>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="loadData"
          :layout="'slot, total, sizes, prev, pager, next, jumper'"
        >
        </pagination>
      </div>
      <el-table :data="tableData">
        <el-table-column label="词" prop="term" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="中文词" prop="termCn" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="分组" prop="typeId" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作人" prop="operNo" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="添加时间"
          prop="createTime"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="handel" label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="handleShowEdit(scope.row)"
              >编辑</el-button
            >
            <el-button type="text" size="mini" @click="deleteRow(scope.row)"
              >删除</el-button
            ><br />
          </template>
        </el-table-column>
      </el-table>
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :title="editDialog.title"
      :visible.sync="editDialog.dialogVisible"
    >
      <el-form
        :model="editDialog.form"
        :rules="editDialog.rules"
        ref="advisoryForm"
        label-width="140px"
      >
        <el-form-item label="词" prop="term">
          <el-input size="small" v-model="editDialog.form.term"></el-input>
        </el-form-item>
        <el-form-item label="中文词" prop="termCn">
          <el-input size="small" v-model="editDialog.form.termCn"></el-input>
        </el-form-item>
        <el-form-item label="分组" prop="typeId">
          <el-input size="small" v-model="editDialog.form.typeId"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="editDialog.dialogVisible = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="handleSave"
          >保存</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="配置分类"
      :visible.sync="classificationVisible"
      destroy-on-close
      width="800px"
    >
     
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/common/Breadcrumb'
import {
  getQuestionList,
  addQuestion,
  updateQuestion,
  deleteQuestion,
} from '@/api/sysSupport/question'
import { getTermList, addTerm, editTerm, removeTerm
 } from '@/api/sysSupport/term'
import { uploadFile } from "@/api/upload/upload"

export default {
  name: "termManage",
  components: { Breadcrumb },
  data() {
    return {
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        term: '',
        termCn: '',
        beginTime: undefined,
        endTime: undefined,
        time: [],
      },
      total: 0,
      tableData: [],
      classificationVisible: false,

      editDialog: {
        title: '',
        dialogVisible: false,
        form: {
          termId: '',
          term: '',
          termCn: '',
          typeId: ''
        },
        fileList: [],
        rules: {
          term: [
            { required: true, message: '请选择词', trigger: 'blur' },
          ],
          termCn: [
            { required: true, message: '请输入中文词', trigger: 'blur' },
          ],
          // typeId: [
          //   { required: true, message: '请输入问题与建议描述 ', trigger: 'blur' },
          // ],

        },
      },
    };
  },
  computed: {
    ...mapGetters(['dictData', 'dictMap']),
  },
  created() {
    this.loadData()
  },
  methods: {
    /** 查询问题列表 */
     showClassification() {
      this.classificationVisible = true
    },
     closeClassification() {
      this.classificationVisible = false
    },
    loadData() {
      this.startLoading()
      if (this.queryParams.time) {
        this.queryParams.manageTimeBegin = this.queryParams.time[0]
        this.queryParams.manageTimeEnd = this.queryParams.time[1]
      } else {
        this.queryParams.manageTimeBegin = undefined
        this.queryParams.manageTimeEnd = undefined
      }
      let params = this._.clone(this.queryParams)
      delete params['time']
      getTermList(params).then((response) => {
        this.tableData = response.rows
        this.total = response.total
        this.endLoading()
      }).catch(()=>{
        this.endLoading()
      })
    },

    resetForm() {
      this.$refs['form'].resetFields()
    },
    handleChange(file, fileList) {
      if(file.size > 20*1024*1024){
        this.msgWarning("文件不能大于20M")
          this.editDialog.fileList = []
      }else{
        this.editDialog.fileList = [file]
      }
    },
    /**显示编辑页面 */
    handleShowEdit(row) {
      if (row.termId) {
        this.editDialog.form = Object.assign({}, row)
        this.editDialog.title = '编辑词'
      } else {
        this.editDialog.form = { isTop: '0' }
        this.editDialog.title = '新增词'
      }
      this.editDialog.dialogVisible = true
      // this.editor.setData(row.content)
    },
     deleteRow(row) {
      this.$confirm('是否确定删除<span style="color: red">'+row.term+'</span>?', "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning"
      }).then(function() {
          return removeTerm({termIds: row.termId});
      }).then(() => {
          this.loadData();
          this.msgSuccess("删除成功");
      }).catch(function() {});
    },

    /**保存问题信息 */
    handleSave() {
      this.$refs['advisoryForm'].validate(async (valid) => {
        if (valid) {
            this.startLoading()

            if (this.editDialog.form.termId) {
              editTerm(this.editDialog.form).then((response) => {
                if (response.code == '200') {
                  this.$message.success('修改成功！')
                  this.editDialog.dialogVisible = false
                  this.endLoading()
                  this.loadData()
                } else {
                  this.endLoading()
                  this.$message.error('修改失败')
                }
              })
            } else {
              addTerm(this.editDialog.form).then((response) => {
                if (response.code == '200') {
                  this.$message.success('新增成功！')
                  this.endLoading()
                  this.editDialog.dialogVisible = false
                  this.loadData()
                } else {
                  this.endLoading()
                  this.$message.error('新增失败')
                }
              })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    /**删除问题 */
    handleDeleteQuestion(row) {
      this.$confirm('确认删除问题？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteQuestion(row).then((response) => {
          if (response.code == '200') {
            this.$message.success('删除成功！')
            this.loadData()
          } else {
            this.$message.error('删除失败！')
          }
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.btn-bar-right {
  text-align: right;
}
</style>
